import { PageContainer } from "@/components/ui";
import { CATEGORY_CARD_COLUMN_CLASS } from "@/domain/storefront-appearance";
import { useStorefrontAppearance } from "@/hooks/use-storefront-appearance";
import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

/**
 * CATEGORY LIST grid, shared by delivery home and table/QR menu. Desktop
 * columns come from `categoryList.cardSize`; mobile is always one.
 */
export function CategoryGrid({ children }: { children: ReactNode }) {
  const { categoryList } = useStorefrontAppearance();

  return (
    <PageContainer
      bottom="chrome"
      data-testid="category-grid"
      className={cn("max-w-shell grid gap-4", CATEGORY_CARD_COLUMN_CLASS[categoryList.cardSize])}
    >
      {children}
    </PageContainer>
  );
}
